/**
 * 토큰 검증 및 인증 관련 유틸리티 함수들
 * httpOnly 쿠키 인증: JWT는 JS에서 읽을 수 없으므로 세션 플래그 + 401 인터셉터에 위임
 */

import { hasAuthSession } from './authConfig';

export interface TokenValidationResult {
	isValid: boolean;
	reason?: 'no-tokens' | 'refresh-expired' | 'invalid-token' | 'access-expired';
}

/** 세션 플래그 기반 로그인 여부 (httpOnly 쿠키 대용 UX 표시) */
export const hasTokens = (): boolean => hasAuthSession();

export const isRefreshTokenExpired = (): boolean => false;

export const isAccessTokenExpired = (): boolean => false;

// useSessionTimer.ts에 있던 것과 동일한 함수, 여기서도 필요
const getSessionExpireAt = (): number | null => {
	const match = document.cookie
		.split('; ')
		.find((c) => c.startsWith('sessionExpireAt='));
	if (!match) return null;
	const value = Number(match.split('=')[1]);
	return Number.isNaN(value) ? null : value;
};

/** HomeContainer 앱 시작 검증 */
export const validateTokensForAppStart = (): TokenValidationResult => {
	const hasSession = hasAuthSession();
	const expireAt = getSessionExpireAt();

	if (!hasSession && expireAt === null) {
		return { isValid: false, reason: 'no-tokens' };
	}
	if (hasSession && expireAt === null) {
		return { isValid: false, reason: 'no-tokens' };
	}
	if (expireAt !== null && Date.now() >= expireAt) {
		return { isValid: false, reason: 'refresh-expired' };
	}

	return { isValid: true };
};

/** API 호출 전 검증 */
export const validateTokensForApiCall = (): TokenValidationResult => {
	if (!hasAuthSession()) {
		return { isValid: false, reason: 'no-tokens' };
	}
	return { isValid: true };
};
